// A magic link's ticket (#…&magic=<ticket>; the fullstack's shared/emails/magicLinks.js, Seán,
// 2026-10-27): taken out of the address as the page opens; signed out, it signs the person in
// (a Clerk sign-in token), the page carrying on to wherever the link went; signed in already,
// it's thrown away (never switching accounts); spent or expired, the address's pre-fill stays
// (prefillEmail.js). As the fullstack's app/utils/magicLink.js.

const MAGIC_PART = /^magic=/i;
const CLERK_WAIT_MS = 15000;

// "#register&magic=abc&email=…" → {ticket: "abc", hash: "#register&email=…"}; none: null
export function takeHashMagic(hash) {
  const parts = String(hash || "").replace(/^#/, "").split("&");
  const found = parts.find((part) => MAGIC_PART.test(part));
  if (found === undefined) return null;
  const rest = parts.filter((part) => part !== found).join("&");
  return {ticket: found.slice("magic=".length).trim(), hash: rest ? `#${rest}` : ""};
}

async function waitForClerk() {
  const start = Date.now();
  while (!window.Clerk?.loaded && Date.now() - start < CLERK_WAIT_MS) {
    await new Promise((resolve) => setTimeout(resolve, 100));
  }
  return window.Clerk?.loaded ? window.Clerk : null;
}

export async function signInWithMagic(ticket) {
  if (!ticket) return;
  const clerk = await waitForClerk();
  if (!clerk || clerk.user) return; // signed in already: thrown away
  try {
    const result = await clerk.client.signIn.create({strategy: "ticket", ticket});
    await clerk.setActive({session: result.createdSessionId});
  } catch {
    // spent or expired: the pre-filled sign-in instead (prefillEmail.js)
  }
}
